module.exports = __webpack_public_path__ + "static/media/americanexpress-dark.c2ea2d77.svg";